<template>
  <div class="app mt-4">
    <v-sheet v-show="showSkeletonForm" class="pa-3">
      <v-row>
        <v-col v-for="n in 4" :key="`line_form_2_col_${n}`">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer v-for="p in 10" :key="`spacer_${p}`" />
        <v-col>
          <v-skeleton-loader type="button" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form v-show="!showSkeletonForm">
      <v-row dense>
        <v-col cols="3">
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col cols="3">
          <v-datetime-picker
            label="Data fim"
            v-model="datetimeend"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>

            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>

            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col cols="3">
          <v-select 
            dense 
            outlined 
            multiple 
            label="Pesquisas" 
            :items="pesquisas" 
            v-model="form.pesquisas"
            :error-messages="pesquisasErrors"
            @input="$v.form.pesquisas.$touch()"
            @blur="$v.form.pesquisas.$touch()"
          >
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.pesquisas.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="togglePesquisas">
                <v-list-item-action>
                  <v-icon :color="form.pesquisas.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconPesquisas }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>

        <v-col cols="3">
          <v-select dense outlined multiple label="Tags" v-model="form.tags" :items="tags">
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.tags.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleTags">
                <v-list-item-action>
                  <v-icon :color="form.tags.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconTags }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col class="text-right">
          <v-btn dark color="bluePcm" @click="gerarRelatorio">Gerar</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="ma-2" />

    <v-sheet v-show="showSkeletonReport" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-if="canShowReport && !showSkeletonReport">
      <ExpansionList :avaliacoes="avaliacoesPaginated" />
      <v-row class="mb-14" align="center">
        <span class="ml-4 grey--text">{{ initialItem }} - {{ finalItem }} de {{ getDadosRelatorio.length }} Itens</span>
        <v-spacer />
        <ListPagination
          :page="currentPage"
          :numberOfPages="lastPageItem"
          @firstPage="firstPage"
          @formerPage="formerPage"
          @nextPage="nextPage"
          @lastPage="lastPage"
        />
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { initialAndFinalDateTextInputReportForm } from '@/mixins/initialAndFinalDateTextInputReportForm'

import { relatoriosPesquisaSatisfacaoMixins } from '../../../mixins/relatoriosPesquisaSatisfacaoMixins'
import relatorioDetalhadoPesquisaSatisfacaoStore from '../_store'

import ExpansionList from '../_components/ExpansionList'
import { validateData, validateComputed } from '../_validates'

export default {
  components: { ExpansionList, ListPagination },
  mixins: [initialAndFinalDateTextInputReportForm, relatoriosPesquisaSatisfacaoMixins],
  data: () => ({
    form: {
      dataHoraInicio: '',
      dataHoraFim: '',
      pesquisas: [],
      tags: [],
    },
    avaliacoes: [],
    avaliacoesPaginated: [],
    itemsPerPage: 20,
    currentPage: 0,
  }),
   validations: {
    ...validateData,
  },

  computed: {
     ...validateComputed,
    ...mapGetters('relatorioDetalhadoPesquisaSatisfacaoStoreModulePesquisaSatisfacaoStore', ['getDadosRelatorio']),

    lastPageItem() {
      return Math.ceil(this.avaliacoes.length / this.itemsPerPage)
    },

    initialItem() {
      return 1 + (this.currentPage - 1) * 20
    },

    finalItem() {
      if (this.initialItem + 19 > this.avaliacoes.length) {
        return this.avaliacoes.length
      }
      return this.initialItem + 19
    },
  },

  async created() {
    this.showSkeletonForm = true

    registerVuexModule(
      this.$store,
      'relatorioDetalhadoPesquisaSatisfacaoStoreModulePesquisaSatisfacaoStore',
      relatorioDetalhadoPesquisaSatisfacaoStore
    )

    await Promise.all([this.listarPesquisasSatisfacao(), this.listarTags()])
    this.pesquisas = this.getPesquisasSatisfacao.map(pesquisa => ({ text: pesquisa.description, value: pesquisa._id }))
    this.tags = this.getTags.map(tag => ({ text: tag.description, value: tag._id }))
    // this.tags.sort(function(a, b){
    //     if(a.text.toLowerCase() < b.text.toLowerCase()) { return -1; }
    //     if(a.text.toLowerCase() > b.text.toLowerCase()) { return 1; }
    //     return 0;
    // })

    this.showSkeletonForm = false
  },

  methods: {
    ...mapActions('relatorioDetalhadoPesquisaSatisfacaoStoreModulePesquisaSatisfacaoStore', ['gerarDadosRelatorio']),

    async gerarRelatorio() {
      this.currentPage = 0
      this.showSkeletonReport = true
      this.form.dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm')
      this.form.dataHoraFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm')

      await this.gerarDadosRelatorio(this.form)
      this.avaliacoes = [...this.getDadosRelatorio]
      this.currentPage = 1
      this.showSkeletonReport = false
      this.canShowReport = true
    },

    async firstPage() {
      if (this.currentPage > 1) {
        this.currentPage = 1
      }
    },
    async formerPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    async nextPage() {
      if (this.currentPage < this.lastPageItem) {
        this.currentPage += 1
      }
    },
    async lastPage() {
      if (this.currentPage < this.lastPageItem) {
        this.currentPage = this.lastPageItem
      }
    },
  },
  watch: {
    currentPage: {
      deep: true,
      handler() {
        this.avaliacoesPaginated.splice(0)

        let initialIndex = (this.currentPage - 1) * 20
        let finalIndex = initialIndex + 20

        if (finalIndex + 1 > this.getDadosRelatorio.length) {
          for (let i = initialIndex; i < this.getDadosRelatorio.length; i++) {
            this.avaliacoesPaginated.push(this.getDadosRelatorio[i])
          }
        } else {
          for (let i = initialIndex; i < finalIndex; i++) {
            this.avaliacoesPaginated.push(this.getDadosRelatorio[i])
          }
        }

        this.avaliacoesPaginated.splice(0, 1, this.avaliacoesPaginated[0])
      },
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
